(function () {
  function initModelierGalleryArrows() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    document.querySelectorAll('media-gallery[data-desktop-layout*="thumbnail"]').forEach((gallery) => {
      if (gallery.dataset.modelierArrowsReady === 'true') return;

      const viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
      const thumbnails = gallery.querySelector('slider-component[id^="GalleryThumbnails"]');

      if (!viewer || !thumbnails) return;

      const thumbnailItems = Array.from(thumbnails.querySelectorAll('[data-target]'));
      if (thumbnailItems.length < 2) return;

      gallery.dataset.modelierArrowsReady = 'true';

      const prevButton = document.createElement('button');
      prevButton.type = 'button';
      prevButton.className = 'modelier-gallery-arrow modelier-gallery-arrow--prev';
      prevButton.setAttribute('aria-label', 'Previous image');
      prevButton.innerHTML = '‹';

      const nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'modelier-gallery-arrow modelier-gallery-arrow--next';
      nextButton.setAttribute('aria-label', 'Next image');
      nextButton.innerHTML = '›';

      viewer.appendChild(prevButton);
      viewer.appendChild(nextButton);

      function getCurrentIndex() {
        const activeThumbButton = thumbnails.querySelector('[data-target] button[aria-current="true"]');
        const activeThumb = activeThumbButton ? activeThumbButton.closest('[data-target]') : null;

        const activeIndex = thumbnailItems.findIndex((item) => item === activeThumb);
        return activeIndex >= 0 ? activeIndex : 0;
      }

      function goToImage(direction) {
        const currentIndex = getCurrentIndex();
        let nextIndex = currentIndex + direction;

        if (nextIndex < 0) nextIndex = thumbnailItems.length - 1;
        if (nextIndex >= thumbnailItems.length) nextIndex = 0;

        const targetButton = thumbnailItems[nextIndex].querySelector('button');
        if (targetButton) {
          targetButton.click();
          thumbnailItems[nextIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }

      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goToImage(-1);
      });

      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goToImage(1);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initModelierGalleryArrows);
  document.addEventListener('shopify:section:load', initModelierGalleryArrows);
})();